// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mr-4 {
  margin-right: 1rem;
}

.ml-6 {
  margin-left: 1.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.pt-4 {
  padding-top: 1rem;
}

.text-primary {
  color: #e9522a !important;
}

.text-primary {
  color: #e9522a !important;
}

.img--small {
  width: 55px;
  height: 55px;
}

.font--bold {
  font-weight: bold !important;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.form-size--half {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 1.25rem;
  column-gap: 1.25rem;
  align-items: start;
}
.form-size--triple {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 1.25rem;
  column-gap: 1.25rem;
  align-items: start;
}
.form-size--one {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: 1.25rem;
  column-gap: 1.25rem;
  align-items: start;
}
.form-size--four {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 1.25rem;
  column-gap: 1.25rem;
  align-items: start;
}

.relative {
  position: relative;
}

.boder-0 {
  border: 0;
}
.boder-bottom {
  border-bottom: 1px solid #eaeaea;
}

*,
::before,
::after {
  box-sizing: border-box;
}

html {
  tab-size: 4;
}

html {
  line-height: 1.15;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}

body {
  margin: 0;
}

body {
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji";
}

hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
}

b,
strong {
  font-weight: bolder;
}

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}

button,
select {
  /* 1 */
  text-transform: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

:-moz-focusring {
  outline: 1px dotted ButtonText;
}

:-moz-ui-invalid {
  box-shadow: none;
}

legend {
  padding: 0;
}

progress {
  vertical-align: baseline;
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

summary {
  display: list-item;
}

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

button {
  background-color: transparent;
  background-image: none;
}

fieldset {
  margin: 0;
  padding: 0;
}

ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

html {
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  /* 1 */
  line-height: 1.5;
  /* 2 */
}

body {
  font-family: inherit;
  line-height: inherit;
}

*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: currentColor;
  /* 2 */
}

hr {
  border-top-width: 1px;
}

img {
  border-style: solid;
}

textarea {
  resize: vertical;
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  color: #9ca3af;
}

button,
[role=button] {
  cursor: pointer;
}

table {
  border-collapse: collapse;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

a {
  color: inherit;
  text-decoration: inherit;
}

button,
input,
optgroup,
select,
textarea {
  padding: 0;
  line-height: inherit;
  color: inherit;
}

pre,
code,
kbd,
samp {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

img,
svg,
video,
canvas,
audio,
embed,
object {
  display: block !important;
  /* 1 */
  vertical-align: middle !important;
  /* 2 */
}

img,
video {
  max-width: 100%;
  height: auto;
}

[hidden] {
  display: none;
}

*,
::before,
::after {
  --tw-border-opacity: 1;
  border-color: rgba(229, 231, 235, var(--tw-border-opacity));
}

body {
  font-family: "Source Sans Pro", sans-serif;
  color: #455673;
}

.font-poppins {
  font-family: "Poppins", sans-serif;
}

.label-validation-error {
  margin-top: 0.25rem;
  color: #ef4444;
  font-size: 0.875rem;
}
.label-validation-error::first-letter {
  text-transform: uppercase;
}

.table-skeleton-container:hover {
  background-color: transparent !important;
}

.datepicker {
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 0 0.75rem;
}
.datepicker div {
  display: flex;
  align-items: center;
  border-left: 1px solid #dadada;
  margin: 0.5rem 0 0.5rem 0.75rem;
  padding: 0.25rem 0;
  padding-left: 0.75rem;
}
.datepicker:hover {
  cursor: pointer;
}
.datepicker .dotted {
  border-radius: 9999px;
  width: 4px;
  height: 4px;
  display: inline-block;
  background-color: #455673;
  margin: 0 0.75rem 0 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/abstracts/_helpers.scss","webpack://./src/components/DatePicker/styles.scss","webpack://./src/assets/scss/base/_reset.scss","webpack://./src/assets/scss/base/_typography.scss","webpack://./src/assets/scss/abstracts/_variables.scss","webpack://./src/assets/scss/components/_label-validation-error.scss","webpack://./src/assets/scss/components/_table-skeleton.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;ACGJ;;ADAA;EACI,mBAAA;ACGJ;;ADAA;EACI,gBAAA;ACGJ;;ADAA;EACI,kBAAA;ACGJ;;ADEQ;EACI,iBAAA;ACCZ;;ADIA;EACI,yBAAA;ACDJ;;ADIA;EACI,yBAAA;ACDJ;;ADKI;EACI,WAAA;EACA,YAAA;ACFR;;ADOI;EACI,4BAAA;ACJR;;ADQA;EACI,mBAAA;EACA,oBAAA;ACLJ;;ADSI;EACI,aAAA;EACA,qCAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;ACNR;ADSI;EACI,aAAA;EACA,qCAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;ACPR;ADUI;EACI,aAAA;EACA,qCAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;ACRR;ADWI;EACI,aAAA;EACA,qCAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;ACTR;;ADaA;EACI,kBAAA;ACVJ;;ADcI;EACI,SAAA;ACXR;ADaI;EACI,gCAAA;ACXR;;AC9EA;;;EAGI,sBAAA;ADiFJ;;AC9EA;EAEI,WAAA;ADiFJ;;AC9EA;EACI,iBAAA;EACA,MAAA;EACA,8BAAA;EACA,MAAA;ADiFJ;;AC9EA;EACI,SAAA;ADiFJ;;AC9EA;EACI,8HAAA;ADiFJ;;AC3EA;EACI,SAAA;EACA,MAAA;EACA,cAAA;EACA,MAAA;AD8EJ;;AC3EA;EACI,yCAAA;EACA,iCAAA;AD8EJ;;AC3EA;;EAEI,mBAAA;AD8EJ;;AC3EA;;;;EAII,wFAAA;EACA,MAAA;EACA,cAAA;EACA,MAAA;AD8EJ;;AC3EA;EACI,cAAA;AD8EJ;;AC3EA;;EAEI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AD8EJ;;AC3EA;EACI,eAAA;AD8EJ;;AC3EA;EACI,WAAA;AD8EJ;;AC3EA;EACI,cAAA;EACA,MAAA;EACA,qBAAA;EACA,MAAA;AD8EJ;;AC3EA;;;;;EAKI,oBAAA;EACA,MAAA;EACA,eAAA;EACA,MAAA;EACA,iBAAA;EACA,MAAA;EACA,SAAA;EACA,MAAA;AD8EJ;;AC3EA;;EAEI,MAAA;EACA,oBAAA;AD8EJ;;AC3EA;;;;EAII,0BAAA;AD8EJ;;AC3EA;EACI,kBAAA;EACA,UAAA;AD8EJ;;AC3EA;EACI,8BAAA;AD8EJ;;AC3EA;EACI,gBAAA;AD8EJ;;AC3EA;EACI,UAAA;AD8EJ;;AC3EA;EACI,wBAAA;AD8EJ;;AC3EA;;EAEI,YAAA;AD8EJ;;AC3EA;EACI,6BAAA;EACA,MAAA;EACA,oBAAA;EACA,MAAA;AD8EJ;;AC3EA;EACI,wBAAA;AD8EJ;;AC3EA;EACI,0BAAA;EACA,MAAA;EACA,aAAA;EACA,MAAA;AD8EJ;;AC3EA;EACI,kBAAA;AD8EJ;;AC3EA;;;;;;;;;;;;;EAaI,SAAA;AD8EJ;;AC3EA;EACI,6BAAA;EACA,sBAAA;AD8EJ;;AC3EA;EACI,SAAA;EACA,UAAA;AD8EJ;;AC3EA;;EAEI,gBAAA;EACA,SAAA;EACA,UAAA;AD8EJ;;AC3EA;EACI,4NAAA;EAEA,MAAA;EACA,gBAAA;EACA,MAAA;AD6EJ;;AC1EA;EACI,oBAAA;EACA,oBAAA;AD6EJ;;AC1EA;;;EAGI,sBAAA;EACA,MAAA;EACA,eAAA;EACA,MAAA;EACA,mBAAA;EACA,MAAA;EACA,0BAAA;EACA,MAAA;AD6EJ;;AC1EA;EACI,qBAAA;AD6EJ;;AC1EA;EACI,mBAAA;AD6EJ;;AC1EA;EACI,gBAAA;AD6EJ;;AC1EA;;EAEI,UAAA;EACA,cAAA;AD6EJ;;AC1EA;;EAEI,eAAA;AD6EJ;;AC1EA;EACI,yBAAA;AD6EJ;;AC1EA;;;;;;EAMI,kBAAA;EACA,oBAAA;AD6EJ;;AC1EA;EACI,cAAA;EACA,wBAAA;AD6EJ;;AC1EA;;;;;EAKI,UAAA;EACA,oBAAA;EACA,cAAA;AD6EJ;;AC1EA;;;;EAII,+GAAA;AD6EJ;;AC1EA;;;;;;;EAQI,yBAAA;EACA,MAAA;EACA,iCAAA;EACA,MAAA;AD4EJ;;ACzEA;;EAEI,eAAA;EACA,YAAA;AD4EJ;;ACzEA;EACI,aAAA;AD4EJ;;ACzEA;;;EAGI,sBAAA;EACA,2DAAA;AD4EJ;;AE1XA;EACE,0CAAA;EACA,cCLW;AHkYb;;AE1XA;EACE,kCAAA;AF6XF;;AItYA;EACI,mBAAA;EACA,cDCU;ECAV,mBAAA;AJyYJ;AIvYI;EACI,yBAAA;AJyYR;;AK9YI;EACI,wCAAA;ALiZR;;AAjZA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAoZJ;AAlZI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,qBAAA;AAoZR;AAjZI;EACI,eAAA;AAmZR;AAhZI;EACI,qBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBG3BK;EH4BL,2BAAA;AAkZR","sourcesContent":[".mr-4 {\n    margin-right: 1rem;\n}\n\n.ml-6 {\n    margin-left: 1.5rem;\n}\n\n.mt-4 {\n    margin-top: 1rem;\n}\n\n.mt-6 {\n    margin-top: 1.5rem;\n}\n\n.p {\n    &t {\n        &-4 {\n            padding-top: 1rem;\n        }\n    }\n}\n\n.text-primary {\n    color: $primary-color !important;\n}\n\n.text-primary {\n    color: $primary-color !important;\n}\n\n.img {\n    &--small {\n        width: 55px;\n        height: 55px;\n    }\n}\n\n.font {\n    &--bold {\n        font-weight: bold !important;\n    }\n}\n\n.text-lg {\n    font-size: 1.125rem;\n    line-height: 1.75rem;\n}\n\n.form-size {\n    &--half {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        column-gap: 1.25rem;\n        align-items: start;\n    }\n\n    &--triple {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        column-gap: 1.25rem;\n        align-items: start;\n    }\n\n    &--one {\n        display: grid;\n        grid-template-columns: repeat(1, 1fr);\n        column-gap: 1.25rem;\n        align-items: start;\n    }\n\n    &--four {\n        display: grid;\n        grid-template-columns: repeat(4, 1fr);\n        column-gap: 1.25rem;\n        align-items: start;\n    }\n}\n\n.relative {\n    position: relative;\n}\n\n.boder {\n    &-0 {\n        border: 0;\n    }\n    &-bottom {\n        border-bottom: 1px solid #eaeaea;\n    }\n}","@import \"../../assets/scss/main\";\n\n.datepicker {\n    background-color: #f5f5f5;\n    display: flex;\n    align-items: center;\n    border-radius: 10px;\n    padding: 0 0.75rem;\n\n    div {\n        display: flex;\n        align-items: center;\n        border-left: 1px solid #dadada;\n        margin: 0.5rem 0 0.5rem 0.75rem;\n        padding: 0.25rem 0;\n        padding-left: 0.75rem;\n    }\n\n    &:hover {\n        cursor: pointer;\n    }\n\n    .dotted {\n        border-radius: 9999px;\n        width: 4px;\n        height: 4px;\n        display: inline-block;\n        background-color: $main-color;\n        margin: 0 0.75rem 0 0.75rem;\n    }\n}\n","*,\n::before,\n::after {\n    box-sizing: border-box;\n}\n\nhtml {\n    -moz-tab-size: 4;\n    tab-size: 4;\n}\n\nhtml {\n    line-height: 1.15;\n    /* 1 */\n    -webkit-text-size-adjust: 100%;\n    /* 2 */\n}\n\nbody {\n    margin: 0;\n}\n\nbody {\n    font-family: system-ui, -apple-system,\n        /* Firefox supports this but not yet `system-ui` */\n        \"Segoe UI\", Roboto,\n        Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\";\n}\n\nhr {\n    height: 0;\n    /* 1 */\n    color: inherit;\n    /* 2 */\n}\n\nabbr[title] {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n}\n\nb,\nstrong {\n    font-weight: bolder;\n}\n\ncode,\nkbd,\nsamp,\npre {\n    font-family: ui-monospace, SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, monospace;\n    /* 1 */\n    font-size: 1em;\n    /* 2 */\n}\n\nsmall {\n    font-size: 80%;\n}\n\nsub,\nsup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n}\n\nsub {\n    bottom: -0.25em;\n}\n\nsup {\n    top: -0.5em;\n}\n\ntable {\n    text-indent: 0;\n    /* 1 */\n    border-color: inherit;\n    /* 2 */\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    font-family: inherit;\n    /* 1 */\n    font-size: 100%;\n    /* 1 */\n    line-height: 1.15;\n    /* 1 */\n    margin: 0;\n    /* 2 */\n}\n\nbutton,\nselect {\n    /* 1 */\n    text-transform: none;\n}\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n    -webkit-appearance: button;\n}\n\n::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n}\n\n:-moz-focusring {\n    outline: 1px dotted ButtonText;\n}\n\n:-moz-ui-invalid {\n    box-shadow: none;\n}\n\nlegend {\n    padding: 0;\n}\n\nprogress {\n    vertical-align: baseline;\n}\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n    height: auto;\n}\n\n[type=\"search\"] {\n    -webkit-appearance: textfield;\n    /* 1 */\n    outline-offset: -2px;\n    /* 2 */\n}\n\n::-webkit-search-decoration {\n    -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    /* 1 */\n    font: inherit;\n    /* 2 */\n}\n\nsummary {\n    display: list-item;\n}\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n    margin: 0;\n}\n\nbutton {\n    background-color: transparent;\n    background-image: none;\n}\n\nfieldset {\n    margin: 0;\n    padding: 0;\n}\n\nol,\nul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\nhtml {\n    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\",\n        Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    /* 1 */\n    line-height: 1.5;\n    /* 2 */\n}\n\nbody {\n    font-family: inherit;\n    line-height: inherit;\n}\n\n*,\n::before,\n::after {\n    box-sizing: border-box;\n    /* 1 */\n    border-width: 0;\n    /* 2 */\n    border-style: solid;\n    /* 2 */\n    border-color: currentColor;\n    /* 2 */\n}\n\nhr {\n    border-top-width: 1px;\n}\n\nimg {\n    border-style: solid;\n}\n\ntextarea {\n    resize: vertical;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n    opacity: 1;\n    color: #9ca3af;\n}\n\nbutton,\n[role=\"button\"] {\n    cursor: pointer;\n}\n\ntable {\n    border-collapse: collapse;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-size: inherit;\n    font-weight: inherit;\n}\n\na {\n    color: inherit;\n    text-decoration: inherit;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    padding: 0;\n    line-height: inherit;\n    color: inherit;\n}\n\npre,\ncode,\nkbd,\nsamp {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\n// iframe,\nembed,\nobject {\n    display: block !important;\n    /* 1 */\n    vertical-align: middle !important;\n    /* 2 */\n}\n\nimg,\nvideo {\n    max-width: 100%;\n    height: auto;\n}\n\n[hidden] {\n    display: none;\n}\n\n*,\n::before,\n::after {\n    --tw-border-opacity: 1;\n    border-color: rgba(229, 231, 235, var(--tw-border-opacity));\n}","@import url(\"https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\nbody {\n  font-family: \"Source Sans Pro\", sans-serif;\n  color: $main-color;\n}\n\n.font-poppins {\n  font-family: \"Poppins\", sans-serif;\n}\n","$main-color: #455673;\n$primary-color: #e9522a;\n$secondary-color: #1a2d47;\n$error-color: #ef4444;\n$header-color: #454545;\n",".label-validation-error {\n    margin-top: 0.25rem;\n    color: $error-color;\n    font-size: 0.875rem;\n\n    &::first-letter {\n        text-transform: uppercase;\n    }\n}\n",".table-skeleton-container {\n    &:hover {\n        background-color: transparent !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
